import { render, staticRenderFns } from "./ParentList.vue?vue&type=template&id=0d349678&scoped=true"
import script from "./ParentList.vue?vue&type=script&lang=js"
export * from "./ParentList.vue?vue&type=script&lang=js"
import style0 from "./ParentList.vue?vue&type=style&index=0&id=0d349678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d349678",
  null
  
)

export default component.exports